// Copyright Materialize, Inc. and contributors. All rights reserved.
//
// Use of this software is governed by the Business Source License
// included in the LICENSE file.
//
// As of the Change Date specified in that file, in accordance with
// the Business Source License, use of this software will be governed
// by the Apache License, Version 2.0.

export const AUTH_ROUTES = {
  loginPath: "/account/login",
  logoutPath: "/account/logout",
};

const AUTH_ROUTES_LIST = Object.values(AUTH_ROUTES);
export function getIsFronteggRoute(pathname: string) {
  return AUTH_ROUTES_LIST.includes(pathname);
}
